import { get, post } from '../services/common/common.service';

import { outOfScopeCasesEndPoints } from '../constants/endpoint';

//Accounting Group Smart Seach - POST API to fetch the data as per payload
export const fetchAccountingGroupsData = (payload) => {
  return post(outOfScopeCasesEndPoints.accountingGroup, payload);
};

//Get OOS Cases List On Grid - GET API to fetch the data as per payload
export const byMultipleInputs = (payload) => {
  return post(outOfScopeCasesEndPoints.oosCasesByMultipleInputs, payload);
};

//Get OOS Cases Summary On Grid - GET API to fetch the data as per payload
export const fetchSummaryData = (payload) => {
  return get(
    `${outOfScopeCasesEndPoints.getSummary}?pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

//Get OOS Case ID - GET API to fetch the data as per payload
export const fetchCaseId = (payload) => {
  return post(outOfScopeCasesEndPoints.getCaseId, payload);
};

export const fetchNotes = (payload) =>{
  return post(outOfScopeCasesEndPoints.getNotes,payload);
}

//Get OOS Cases Details
export const fetchCaseDetails = (payload) => {
  return get(
    `${outOfScopeCasesEndPoints.getCaseDetails}?caseId=${payload}`
  );
};

//Get OOS Cases Site Details
export const fetchCaseSiteDetails = (payload) => {
  return get(
    `${outOfScopeCasesEndPoints.getCaseSiteDetails}?caseId=${payload}`
  );
};

//Get OOS Cases Items
export const fetchOOSCaseItems = (payload) => {
  return get(
    `${outOfScopeCasesEndPoints.getOOSCaseItems}?caseId=${payload.caseId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

//Get OOS Cases Item History
export const fetchOOSCaseItemHistory = (payload) => {
  return get(
    `${outOfScopeCasesEndPoints.getOOSCaseItemHistory}?outScopeFeeId=${payload.outScopeFeeId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
}

//Get OOS Cases Item Comment
export const fetchOOSCaseItemComment = (payload) => {
  return get(
    `${outOfScopeCasesEndPoints.getOOSCaseItemComment}?caseId=${payload.caseId}&outScopeId=${payload.outScopeId}`
  );
}

//Get OOS Cases Item RMA
export const fetchOOSCaseItemRMA = (payload) => {
  return get(
    `${outOfScopeCasesEndPoints.getOOSCaseItemRMA}?caseId=${payload.caseId}&outScopeId=${payload.outScopeId}`
  );
}

//Save OOS Cases Items
export const saveOOSCaseItems = (payload) => {
  return post(outOfScopeCasesEndPoints.saveOOSCaseItems, payload);
}